import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/tbh/logo.svg';
import Sidebar from './Sidebar';

const LeftNavigation = () => {
  return (
    <nav className='hidden md:block fixed h-[100%]  bg-offDark top-0 left-0 md:w-[235px] '>
      <div className='flex pb-[28px] bg-[#028789] flex-col items-center  justify-center space-y-3 md:pt-6'>
        <Link className='block' to='/'>
          <img
            style={{
              width: '200px',
              height: '42px',
            }}
            src={logo}
            alt='tbh-logo'
          />
        </Link>
      </div>
      <Sidebar />
    </nav>
  );
};

export default LeftNavigation;
